import { render, staticRenderFns } from "./TeachResources.vue?vue&type=template&id=6c3d7b05&"
import script from "./TeachResources.vue?vue&type=script&lang=js&"
export * from "./TeachResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports